import Manager from 'common/domain/models/foodBenefitManager';

class managerDataAssembler {
  static assemble(data) {
    let manager = new Manager();
    manager.profile = {
      hireDate : data.managerProfile.hireDate,
      managerId : data.managerProfile.managerId,
      image: data.managerProfile.image,
      name: data.managerProfile.name
    };
    manager.employeesFoodBenefitPeriods = data.employeesFoodBenefitPeriods;
    return manager;
  }
}

export default managerDataAssembler;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/managerRepository/managerRepository.assemblers.js